<template>
	<div class="timetable" :style="removePageBreak ? 'page-break-inside: auto' : ''">
		<egranty-section-divider class="mt-4" text="Opis działań" icon="date_range"
			:show-print-info="showPrintInfo"></egranty-section-divider>
		<div v-for="action in actions" :key=action.name>
			<v-card class="mt-1">

				<v-card-title style="background-color: #ABABAB">
					<h2>{{ action.serialNumber }}. {{ action.action }}</h2>
				</v-card-title>

				<v-card-text>

					<v-layout row mt-2 ml-4>
						<div>
							<strong>Miejsce: </strong> <span>{{ action.place }}</span>
						</div>
					</v-layout>

					<v-layout row mt-2 ml-4>
						<div>
						<strong>Opis: </strong> <span>{{ action.description }}</span>
					</div>
					</v-layout>

					<choose-beneficiaries-read-only-view v-if="contestId !== null" v-model="action.beneficiariesData"
						:contestId="contestId"></choose-beneficiaries-read-only-view>

					<v-layout mt-2 ml-4>
						<div class="mb-3">
							<strong>Okresy realizacji:</strong>
							<div class="mt-2">
								<ul>
									<li class="ml-4" v-for="(dates, datesIndex) in action.realizationDates"
										:key='datesIndex'>
										{{ datesIndex + 1 }}. {{ dates.start }} - {{ dates.end }}
									</li>
								</ul>
							</div>
						</div>
					</v-layout>

				</v-card-text>

			</v-card>
		</div>
	</div>
</template>

<script>
import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
import ChooseBeneficiariesReadOnlyView from "./ReadOnlyComponents/ChooseBeneficiariesReadOnlyView";
export default {
	name: "ContestOfferActivitiesDescription",
	components: { EgrantySectionDivider, ChooseBeneficiariesReadOnlyView },
	props: {
		actions: {
			type: Array,
			default: () => [],
		},
		showPrintInfo: {
			type: Boolean, default: false
		},
		removePageBreak: {
			type: Boolean, default: false
		},
		contestId: {}
	},
};
</script>

<style scoped></style>
